import { axiosInstance } from '../axios';

const API_URL = '/api/devices';

class DevicesService {
  async getDevices(
    filterDeviceId = null,
    deviceProperty = 'identification',
    valueOrder = 'DESC',
    limit = 5,
    offset = 0) {
    return axiosInstance
      .get(
        `${API_URL}/devices?deviceProperty=${deviceProperty}&valueOrder=${valueOrder}&limit=${limit}&offset=${offset}${
        filterDeviceId ? '?filterDeviceId=' + filterDeviceId : ''
        }`,
      )
      .then((res) => {
        if (res.data) return res.data;
      });
  }

  async findDevicesByNameOrIdentification(searchTerm, mustIncludeIds) {

    const params = new URLSearchParams();

    if (searchTerm !== null) {
      params.append('searchTerm', searchTerm);
    }
    if (mustIncludeIds) {
      mustIncludeIds.forEach(id => {
        params.append('mustIncludeIds', id);
      });
    }

    const config = {
      params: params,
    };
    return axiosInstance.get(`${API_URL}/findDevicesByNameOrIdentification`, config);
  }

  async addDevice(device) {
    return await axiosInstance.put(API_URL + '/device', device);
  }

}

export default new DevicesService();
